import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from 'app/modules/common/constants/constants';
import { AbsenteeismChartTypes } from 'app/modules/common/enums/absenteeism-chart-types';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ChartService } from 'app/modules/coordinator/services/chart.service';
import { CoordinatorStatisticsService } from 'app/modules/coordinator/services/coordinator-statistics.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { ChartDataset, ChartOptions } from 'chart.js';
import 'chart.js/auto';

import { ChartPopupComponent } from '../chart-popup/chart-popup.component';

@Component({
    selector: 'app-absenteeism-chart',
    templateUrl: './absenteeism-chart.component.html',
    styleUrls: ['./absenteeism-chart.component.scss'],
    standalone: false
})
export class AbsenteeismChartComponent implements OnInit {

  public chartOptions: ChartOptions;
  public absenteeismData: ChartDataset<'line'>[];

  public isLoading = true;
  public selectedCompanyId = 0;

  constructor(
    private coordinatorStatisticsService: CoordinatorStatisticsService,
    private sharedService: SharedService,
    private empresaTreeViewService: EmpresaTreeViewService,
    public chartService: ChartService,
    private dialog: MatDialog) {
    this.registerTreeViewListener();
  }

  ngOnInit(): void {
    this.selectedCompanyId = JSON.parse(localStorage.getItem('Empresa'));
    this.initChart();
    if(this.selectedCompanyId > 0) {
      this.getAbsemteeismData();
    }
  }

  public initChart(): void {
    this.chartOptions = {
      responsive: true , elements : { line: {tension : 0.4}}
    };
  }

  private registerTreeViewListener(): void {
    this.empresaTreeViewService.EmpId.subscribe(res => {
      this.selectedCompanyId = res;
      if (this.selectedCompanyId > 0 && !this.coordinatorStatisticsService.isStatisticsHidden) {
        this.getAbsemteeismData();
      }
    });
  }

  private getAbsemteeismData(): void {
    this.isLoading = true;
    this.coordinatorStatisticsService.GetAbsenteeismData(String(this.selectedCompanyId)).subscribe(res => {
      if (res.code === 0) {
        const chartData = res.result ;

        if(chartData && chartData.length) {
          this.chartService.setAbsenteeismData(chartData);
          this.absenteeismData = this.chartService.getAbsenteeismData(AbsenteeismChartTypes.All) as ChartDataset<'line'>[];
        }
        
      } else {
        this.sharedService.ShowSnackBar('No pudo liderar los datos de absentismo.');
      }

      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public openChartPopup(): void {
    const modalRef = this.dialog.open(ChartPopupComponent, {
      panelClass: 'full-screen-modal',
      width: '1530px',
      height: '830px'
    });

    modalRef.componentInstance.selectedChartType = AbsenteeismChartTypes.All;
  }

}
